import Vue from "vue";
import Vuex from "vuex";
import Cookies from "js-cookie";
const TOKEN_NAME = "grading-token";

import { userRouter } from "@/router";

import { login, logout, getUserInfo } from "@/api/user";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //用户
    user: null,
    //国籍
    guoji: require("@/assets/data/country").data || [],
    //民族
    minzu: require("@/assets/data/nation").data || [],
    //手机端底部tabbar数组
    tabbar: [
      {
        title: "官网首页",
        url: "https://mskj.caa.edu.cn",
        icon: "home",
        type: "external"
      },
      // {
      //   title: "在线报名",
      //   url: "/sign-up",
      //   icon: "xiugaijilu"
      // },
      {
        title: "考场查询",
        url: "/room-query",
        icon: "dalou"
      },
      {
        title: "证书查询",
        url: "/certificate-query",
        icon: "chengjichaxun"
      },
      {
        title: "我的",
        url: "/home",
        icon: "center"
      }
    ]
  },
  getters: {
    //登录状态标记
    status: state => (state.user ? true : false),
    //动态路由数组
    GenerateRoutes: state => {
      return userRouter;
    }
  },
  mutations: {
    //设置用户
    SET_USER(state, user) {
      state.user = user;
    }
  },
  actions: {
    //登录
    login({ commit }, data) {
      return new Promise((resolve, reject) => {
        login(data)
          .then(res => {
            if (res) {
              if (res.code === 200 && res.data.member_type === "student") {
                Cookies.set(TOKEN_NAME, res.data.token, { expires: 1 });
              }
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    //退出
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        logout()
          .then(res => {
            Cookies.remove(TOKEN_NAME);
            commit("SET_USER", null);
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    // 获取用户信息
    getUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then(res => {
            if (res && res.code === 200) {
              commit("SET_USER", res.data);
              resolve(res);
            } else {
              reject();
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
});
